if (!customElements.get('content-truncator')) {

  class ContentTruncator extends HTMLElement {
    connectedCallback() {
      // Use connectedCallback instead of initScriptOnDemand
      this.contentWrapper = this.querySelector('.content-truncator__wrapper');
      this.content = this.querySelector('.content-truncator__content');
      this.button = this.querySelector('.content-truncator__button');

      if (!this.contentWrapper || !this.content || !this.button) return;

      this.updateButtonVisibility();

      this.button.addEventListener('click', () => this.toggleContent());
      window.addEventListener('resize', () => {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => this.updateButtonVisibility(), 200);
      });
    }

    updateButtonVisibility() {
      // Temporarily remove max-height to measure true content height
      const currentMaxHeight = this.contentWrapper.style.maxHeight;
      this.contentWrapper.style.maxHeight = 'none';
      const contentHeight = this.content.scrollHeight;
      this.contentWrapper.style.maxHeight = currentMaxHeight;

      const wrapperCollapsedHeight = 115; // Match your inline style

      if (contentHeight > wrapperCollapsedHeight) {
        this.contentWrapper.classList.add('is-expandable');
        this.button.style.display = 'inline-block';
      } else {
        this.contentWrapper.classList.remove('is-expandable');
        this.button.style.display = 'none';
      }
    }

    toggleContent() {
      if (this.contentWrapper.classList.contains('expanded')) {
        this.showLessContent();
      } else {
        this.showMoreContent();
      }
    }

    showMoreContent() {
        this.contentWrapper.style.maxHeight = 'none';
        this.contentWrapper.classList.add('expanded');
        this.button.textContent = 'Show less';
    }

    showLessContent() {
        this.contentWrapper.style.maxHeight = '115px';
        this.contentWrapper.classList.remove('expanded');
        this.button.textContent = 'Show more';
    }
  }

  customElements.define('content-truncator', ContentTruncator);
}